'use strict';

var React = require('react');

var SvgSectionMajor = function SvgSectionMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 1a1 1 0 0 0-1 1v2h2v-1h1v-2h-2zm16 0a1 1 0 0 1 1 1v2h-2v-1h-1v-2h2zm-17 5v8h18v-8h-18zm1 13a1 1 0 0 1-1-1v-2h2v1h1v2h-2zm17-1a1 1 0 0 1-1 1h-2v-2h1v-1h2v2zm-13-1h3v2h-3v-2zm8 0h-3v2h3v-2zm0-16v2h-3v-2h3zm-5 2v-2h-3v2h3z"
  }));
};

exports.SvgSectionMajor = SvgSectionMajor;
